import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => {
  return createStyles({
    header: {
      marginBottom: '1%',
    },
    gridContainer: {
      height: '500px',
    },
  });
});
